import React from 'react';
import './Banner.css';

const Banner = () => {
    return (
        <div className="bg-img row m-0">
            <div className=" p-5">
                <h1>LET’S YOUR JOURNEY BEGINS</h1>
                <p>The most popular state for tourism in the U.S. endured record wildfires, drought and flooding just this year. “The rate of change has been so dramatic,” says one local scientist. “If I was the California tourism industry, I’d be really worried.”</p>
                <button className="btn-details">LEARN MORE</button>
            </div>

        </div>
    );
};

export default Banner;